var React = require('react');

function Pencil (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"64","height":"64","rx":"4","fill":"#1B68FF","key":0}),React.createElement("path",{"d":"M16 40.76v6.51h6.67l19.66-19.21-6.67-6.51L16 40.75zm31.48-17.74c.7-.68.7-1.77 0-2.45l-4.16-4.06a1.8 1.8 0 00-2.5 0l-3.26 3.18 6.67 6.51 3.25-3.18z","fill":"#fff","key":1})]);
}

Pencil.defaultProps = {"viewBox":"0 0 64 64","fill":"none"};

module.exports = Pencil;

Pencil.default = Pencil;
